import { useContext } from 'react';
import { SafeImage } from '@/components/common/safe-image';
import { SymbolContext } from '../symbol-context';

export type StickerProps = { id: number; url: string };

const Sticker = ({ url }: StickerProps) => {
  const { sendSticker } = useContext(SymbolContext);

  return (
    <button
      type='button'
      className='select-none flex flex-center w-full aspect-square'
      onClick={() => sendSticker(url)}>
      <SafeImage
        className='size-12 bg-cover bg-transparent'
        src={url}
        size={[48, 48]}
      />
    </button>
  );
};
export default Sticker;
